import * as React from "react";
import StoreContainer from "../stores/StoreContainer";
import Loading from "./Loading";
const querystring = require("querystring");

interface Props {
  calendarName: string;
  onBookMeeting: () => void;
}

function Calendly(props: Props) {
  const [loading, setLoading] = React.useState(true);
  const el = React.useRef<HTMLDivElement>();

  function calendlyLoaded(e: any) {
    return e.data.event && e.data.event === "calendly.loaded";
  }

  function eventScheduled(e: any) {
    return e.data.event && e.data.event === "calendly.event_scheduled";
  }

  async function onReceiveMessage(e: any) {
    if (eventScheduled(e)) {
      await props.onBookMeeting();
    } else if (calendlyLoaded(e)) {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    const currentDocument = el.current.ownerDocument;
    currentDocument.defaultView.addEventListener("message", onReceiveMessage);
    return () => {
      currentDocument.defaultView.removeEventListener(
        "message",
        onReceiveMessage
      );
    };
  }, []);

  const visitorInfo = StoreContainer.VisitorStore.getVisitorInfo();
  const qs = querystring.stringify({
    calendar: props.calendarName,
    name: visitorInfo.DisplayName,
    email: visitorInfo.EmailAddress
  });

  return (
    <div className="calendly-frame" ref={el}>
      {loading && (
        <div className="loading">
          <Loading />
        </div>
      )}
      <iframe
        src={`${StoreContainer.SettingStore.getCdnEndpoint()}/calendly?${qs}`}
      />
    </div>
  );
}

export default Calendly;
